export { default, type IProps as IAllurLoaderProps } from './allur-loader';
